import React from 'react';
import './BlinkingBatteryIcon.css';

const BlinkingBatteryIcon = (props) => {
  return <i className="blinking-battery-icon material-icons" {...props}>battery_charging_full</i>;
};

export default BlinkingBatteryIcon;
